var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcOutlineEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 4.49935C14.6654 3.76602 14.0654 3.16602 13.332 3.16602H2.66536C1.93203 3.16602 1.33203 3.76602 1.33203 4.49935V12.4993C1.33203 13.2327 1.93203 13.8327 2.66536 13.8327H13.332C14.0654 13.8327 14.6654 13.2327 14.6654 12.4993V4.49935ZM13.332 4.49935L7.9987 7.83268L2.66536 4.49935H13.332ZM13.332 12.4993H2.66536V5.83268L7.9987 9.16602L13.332 5.83268V12.4993Z",
    fill: "#04245C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 4.49935C14.6654 3.76602 14.0654 3.16602 13.332 3.16602H2.66536C1.93203 3.16602 1.33203 3.76602 1.33203 4.49935V12.4993C1.33203 13.2327 1.93203 13.8327 2.66536 13.8327H13.332C14.0654 13.8327 14.6654 13.2327 14.6654 12.4993V4.49935ZM13.332 4.49935L7.9987 7.83268L2.66536 4.49935H13.332ZM13.332 12.4993H2.66536V5.83268L7.9987 9.16602L13.332 5.83268V12.4993Z",
    fill: "#04245C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0013 9.16667L2.66797 5.83333V4.5L8.0013 7.83333L13.3346 4.5V5.83333L8.0013 9.16667Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOutlineEmail);
export default __webpack_public_path__ + "static/media/ic_outline-email.729d9022679485405fee23a67fa91404.svg";
export { ForwardRef as ReactComponent };